<template>
  <v-img
    style="cursor: zoom-in"
    :src="props.src"
    :height="props.height"
    @click="dialog = true"
  >
    <v-dialog v-model="dialog" max-width="95vw" min-height="400">
      <v-img
        @click="dialog = false"
        style="cursor: zoom-out"
        :src="props.src"
        contain
        max-width="100%"
        max-height="90vh"
      />
    </v-dialog>
  </v-img>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
  src: String,
  height: String,
});

const dialog = ref(false);
</script>
